import { IDimensions, useWidgetContext } from '@dxp-module/common'
import generateApolloClient from '../graphql/generateApolloClient'

const useApolloClient = () => {
  const { configuration } = useWidgetContext()
  const client = generateApolloClient(configuration.dimensions as IDimensions)

  return { client }
}

export default useApolloClient
